import { DynamicStandaloneIcon } from '@/components/Icon';
import { ClassNameProvider } from '@/styles/Accordion';
import type { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { useAppState } from 'lib/hooks/useAppState';
import { ReactNode } from 'react';
import { useToggle } from 'react-use';
import { Accordion } from './Accordion';

export interface StandaloneAccordionProps extends StandaloneComponentProps<typeof Accordion> {
  title?: ReactNode;
  content?: ReactNode;
  toggle?: React.ReactNode;
}

export const StandaloneAccordion: StandaloneComponent<StandaloneAccordionProps> = ({
  title,
  content,
  toggle,
  options,
  ...props
}) => {
  const [{ device }] = useAppState();
  const [isOpen, toggleOpen] = useToggle(device === 'desktop');

  const { $toggle, $group, $content, ...$base } = options ?? {};

  return (
    <ClassNameProvider value={$base}>
      <Accordion {...$base} {...props} data-open={isOpen ? '' : undefined}>
        <Accordion.Group {...$group}>
          {title}
          <Accordion.Toggle onClick={toggleOpen} {...$toggle}>
            {toggle ?? <DynamicStandaloneIcon name="showMore" options={{ size: 'medium' }} />}
          </Accordion.Toggle>
        </Accordion.Group>
        <Accordion.Content {...$content}>{content}</Accordion.Content>
      </Accordion>
    </ClassNameProvider>
  );
};

export default StandaloneAccordion;
